enum EnumLang {
	en = 0,
	ru = 1
}
export default EnumLang
